export function formatCurrency(amount) {
  if (amount == null || typeof amount !== 'number' || isNaN(amount)) return '$0'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export function formatCurrencyExact(amount) {
  if (amount == null || typeof amount !== 'number' || isNaN(amount)) return '$0.00'
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount)
}

export function formatPercent(value) {
  if (value == null || typeof value !== 'number' || isNaN(value)) return '0%'
  return `${Math.round(value * 10) / 10}%`
}

export function formatDate(dateStr) {
  if (!dateStr || dateStr === 'Unknown') return 'Unknown'
  const d = new Date(dateStr + 'T00:00:00')
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function formatCompactNumber(num) {
  if (num == null || typeof num !== 'number' || isNaN(num)) return '0'
  if (Math.abs(num) >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`
  if (Math.abs(num) >= 1_000) return `${(num / 1_000).toFixed(1)}K`
  return num.toFixed(0)
}
